import copyObject from './_copyObject';
import getSymbols from './_getSymbols';

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

export default copySymbols;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_copySymbols.js
// module id = 328
// module chunks = 0